import { connect } from 'react-redux';
import addSectionAction from '../../actions/compose-report-tool/add-section';
import addAllSectionsAction from '../../actions/compose-report-tool/add-all-sections';
import removeAllSectionsAction from '../../actions/compose-report-tool/remove-all-sections';
import removeSectionAction from '../../actions/compose-report-tool/remove-section';
import copyToClipboardAction from '../../actions/compose-report-tool/copy-to-clipboard';

import ComposeReportTool from './component';

const mapStateToProps = state => ({
    selectproduct: state.selectproduct.get('selectproduct'),
    content: state.content.get('content'),
    selectedsections: state.selectedsections.get('selectedsections'),
    copytoclipboardrequested: state.selectedsections.get('copytoclipboardrequested'),
    copytoclipboardcompleted: state.selectedsections.get('copytoclipboardcompleted'),
});

const mapDispatchToProps = dispatch => ({
    addSection: async (slug) => {
        await dispatch(await addSectionAction(slug));
    },
    addAllSections: async () => {
        await dispatch(await addAllSectionsAction());
    },
    removeAllSections: async () => {
        await dispatch(await removeAllSectionsAction());
    },
    removeSection: async (slug) => {
        await dispatch(await removeSectionAction(slug));
    },
    copyToClipboard: async () => {
        await dispatch(await copyToClipboardAction());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ComposeReportTool);
